import { render, staticRenderFns } from "./areaModal.vue?vue&type=template&id=0f273001&scoped=true"
import script from "./areaModal.vue?vue&type=script&lang=js"
export * from "./areaModal.vue?vue&type=script&lang=js"
import style0 from "./areaModal.vue?vue&type=style&index=0&id=0f273001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f273001",
  null
  
)

export default component.exports